import { clearStorage, LogoutMechanism } from "../constant/helper";
import { ProfileReduxTypes } from "../constant/Types";
import { getProfile } from "../pages/profile/profile.api";

export const updateProfile = (data) => {
  return {
    type: ProfileReduxTypes.update,
    data,
  };
};

export const fetchProfile = () => (dispatch) => {
  dispatch({
    type: ProfileReduxTypes.FETCH_PROFILE,
  });

  getProfile()
    .then((response) => {
      if (response.data.deleted) {
        LogoutMechanism();
      }
      if(response.data.beta){
        localStorage.setItem("beta", true);
      }
      dispatch({
        type: ProfileReduxTypes.FETCH_PROFILE_SUCCESS,
        data: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: ProfileReduxTypes.FETCH_PROFILE_FAILURE,
        payload: error,
      });
    });
};

export const signOut = () => (dispatch) => {
  dispatch({
    type: ProfileReduxTypes.logout,
  });

  clearStorage();

  // window.location.pathname = "/login";
};
